import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { WechatOutlined } from '@ant-design/icons';
import unit from '../unit';

// 登录组件
const LoginComponent = ({ showLogin, closeLogin }) => {
  useEffect(() => {
    let callbackUrl = unit.getBaseHost() + '/code.html';
    if (showLogin) {
      // 创建 WxLogin 实例
        new window.WxLogin({
          self_redirect: false, // 是否自动跳转
          id: "login_container", // 容器ID
          appid: "wx5e5de025fc8161f2", // 微信APPID
          scope: "snsapi_login", // 授权类型
          redirect_uri: encodeURIComponent(callbackUrl), // 回调地址
          state: "STATE", // 用于第三方应用防止CSRF攻击
          fast_login: 1,
          onReady: function (isReady) {
            console.log(isReady ? "微信登录准备完成" : "微信登录准备失败");
          }
        });
    }

    const hander = setInterval(function(){
      const token = unit.getToken();
      const userId = window.localStorage.getItem("user_id");
      if (token && userId > 0) {
        closeLogin();
        clearInterval(hander);
      }
    }, 500);
    
  }, [showLogin]);

  return (
    <Modal open={showLogin} footer={null} onCancel={closeLogin}>
      <div className='login'>
        <h2 className='title'>Hi！欢迎加入仓位在线</h2>
        <p className='desc'>首次登录将自动注册</p>
        <div className='qrcode' id="login_container" style={{ 
          display: 'flex',          
          justifyContent: 'center', 
          alignItems: 'center',     
          textAlign: 'center'       
        }}>
          {/* 微信登录的二维码将通过 WxLogin 实例化后渲染到此容器中 */}
        </div>
        <p className='xieyi'>
          注册登录即代表您已阅读并同意
          <a href="https://api.duishu.com/agreement/detail?id=1210535">《用户服务协议》</a>
          <a href="https://api.duishu.com/agreement/detail?id=1209951">《隐私政策》</a>
        </p>
      </div>
    </Modal>
  );
};

export default LoginComponent;